import request from "@/utils/request";
import { Message } from "element-ui";
// 查看分页列表
export function shopcheckrecordPage(params) {
  return request({
    url: `/shop/shopcheckrecord/page`,
    method: "get",
    params,
  });
}

// 查看详情
export function shopcheckrecordInfo(id) {
  return request({
    url: `/shop/shopcheckrecord/info/${id}`,
    method: "get",
  });
}

// 检查商户
export function checkShop(data) {
  return request({
    url: `/shop/shopcheckrecord/checkShop`,
    method: "post",
    data: data,
  });
}

// 根据类型获取商铺列表 （0-客户，1-商户）
export function getListByType(params) {
  return request({
    url: `/shop/shoptype/getListByType`,
    method: "GET",
    params,
  });
}

//  客户管理 /shop-----
//查询客户管理列表信息
export function getClientPage(params) {
  return request({
    url: `/shop/ops/client/page`,
    method: "GET",
    params,
  });
}

export function getClientPageNew(data) {
  return request({
    url: `/statistic/com/ops/client/page`,
    method: "POST",
    data,
  });
}

//更新客户启用状态     关店操作的
export function updateClientStatus(data) {
  return request({
    url: `/shop/ops/client/update`,
    method: "post",
    data: data,
  });
}

// 商户管理----
export function queryShopManageList(data) {
  return request({
    url: `/shop/shopManage/queryShopManageList`,
    method: "post",
    data: data,
  });
}

// 修改商户保证金信息/

// export function updateShopSecurityDeposit(data) {
//     return request({
//         url: `/shop/shopManage/updateShopSecurityDeposit`,
//         method: 'post',
//         data :data
//     })
// }

// 修改商户保证金信息/
export function updateSetThreshold(data) {
  return request({
    url: `/payment/guarantee/platform/setThreshold`,
    method: "post",
    data: data,
  });
}

// 获取商户保证金信息//
export function getPlatformGuaranteeInfo(data) {
  return request({
    url: `/payment/guarantee/platform/info`,
    method: "GET",
    params: data,
  });
}

// guarantee/platform/setThreshold

// /shopManage/updateShopRate  修改商户经营范围费率
export function updateShopRate(data) {
  return request({
    url: `/shop/shopManage/updateShopRate`,
    method: "post",
    data: data,
  });
}

// /invoice/compliance/cominvoiceproperty/detail  查询开票设置信息
export function cominvoiceproperty(params) {
  return request({
    url: `/invoice/compliance/cominvoiceproperty/detail/${params.shopId}`,
    method: "GET",
    // params
  });
}

// /shopManage/updateBusinessStatus  根据商户id更新业务状态

export function updateBusinessStatus(data) {
  return request({
    url: `/shop/shopManage/updateBusinessStatus`,
    method: "post",
    data: data,
  });
}
// /shopManage/queryShopManageDetails/{shopId}

export function queryShopManageDetails(params) {
  return request({
    url: `/shop/shopManage/queryShopManageDetails/${params.shopId}`,
    method: "GET",
  });
}

// 查询分账详情
export function findOrderSettlementDetail(params) {
  return request({
    url: `/payment/compensate/findOrderSettlementDetail?orderCode=${params.orderCode}`,
    method: "POST",
    data: params,
  });
}

// 执行补单
export function doFixOrderSettlement(data) {
  return request({
    url: `/payment/compensate/doFixOrderSettlement?orderCode=${data.orderCode}`,
    method: "POST",
    data: data,
  });
}

// /order/sys/sale/page
// 销售订单列表
export function orderSalePage(data) {
  return request({
    url: `/order/order/sys/sale/page`,
    method: "POST",
    data,
  });
}
// 销售订单列表 - 统计
export function orderSaleCollect(data) {
  return request({
    url: `/order/order/sys/sale/collect`,
    method: "POST",
    data,
  });
}
// 查看合同
export function getDownloadUrl(data) {
  return request({
    url: `/invoice/faddContract/getDownloadUrl`,
    method: "get",
    params: data,
  });
}

// 订单评论审核列表
export function examineList(params) {
  return request({
    url: `/order/order/comment/examineList`,
    method: "get",
    params,
  });
}

//查询评论详情
//   /order/comment/getCommentById
export function getCommentById(params) {
  return request({
    url: `/order/order/comment/getCommentById`,
    method: "get",
    params,
  });
}
//   /order/comment/passOrReject
// 通过或驳回 订单评论
export function passOrReject(params) {
  return request({
    url: `/order/order/comment/passOrReject`,
    method: "get",
    params,
  });
}
// 获取系统用户
export function getUserListByPhone(params) {
  return request({
    url: `/member/info/user/list`,
    method: "get",
    params,
  });
}
// 换绑管理账号
export function changeShopUserAdmin(data) {
  return request({
    url: `/shop/ops/client/binding?shopId=${data.shopId}&userId=${data.userId}`,
    method: "put",
    data,
  });
}
// 导出销售订单
export function exportSaleOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: `/order/order/sys/sale/export`,
      method: "post",
      responseType: "blob",
      data: data,
    })
      .then((response) => {
        const blob = response.data;
        if (!blob || blob.size === 0) {
          Message.warning("内容为空，无法下载");
          return resolve();
        }

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        const contentDisposition = response.headers["content-disposition"];
        const fileName = decodeURIComponent(contentDisposition.split("=")[1]);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
          Message.success("导出成功");
          resolve();
        }, 0);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
